import React, { FC } from 'react'
import { LayoutPresenterScreenProps } from './types'
import styles from './LayoutPresenterScreen.module.scss'
import { ScreenGroup } from '../../Screen'
import PresenterScreenItem from '../PresenterScreenItem'
import SlidesScreen from '../../SlidesScreen'
import StreamScreen from '../../EventStreaming/StreamScreen'
import classnames from 'classnames'
import PlayInScreen from '../../PlayInScreen'
import LayoutsSidebar from '../../Layouts/LayoutsSidebar'
import { mediaType as MediaType } from '@bt-react/constants'
import { StructuredPresenterInterface } from '../../../dataStore/selectors/structuredSelectPresenter/types'
import SpotlightControls from '../../SpotlightControls/index'
import { LayoutType } from '../../../dataStore/slices/layouts/layoutsSlice'
import { OBSERVER } from '../../../dataStore/constants/roles'

const presenterScreenItemReturn = (maxPresenters: number, presenters: StructuredPresenterInterface[], presenter?: StructuredPresenterInterface) =>
  presenters.map((presenterData) => presenter?.BTID !== presenterData.BTID ? undefined :
    <PresenterScreenItem
      key={`layout-screen-item-${presenterData.BTID}`}
      presenter={presenterData}
    />
  ).slice(0, maxPresenters)

const getScreenFromMediaType = (mediaType: MediaType, presenters: StructuredPresenterInterface[], observers: StructuredPresenterInterface[],
  maxPresenters: number, focusedPresenter?: StructuredPresenterInterface, screenSharingPresenter?: StructuredPresenterInterface, muted?: boolean) => {

  switch (mediaType) {

    case MediaType.SLIDES:
      return <SlidesScreen />
    case MediaType.PLAY_IN:
      return <PlayInScreen isMuted={muted || false} />
    case MediaType.SCREENSHARE:
      const presentersAndObserversArr = presenters.concat(observers)
      return presenterScreenItemReturn(maxPresenters, presentersAndObserversArr, screenSharingPresenter)
    case MediaType.SPOTLIGHT:
      return presenterScreenItemReturn(maxPresenters, presenters, focusedPresenter)
    case MediaType.EVENT_STREAM:
      return <StreamScreen isMuted={muted || false} />
    default:
      return

  }

}

const removeObservers = (presenters: StructuredPresenterInterface[]) => presenters.filter((presenter) => presenter.role !== OBSERVER)

const getSidebarClasses = (presenterLength: number, mediaType: MediaType, mediaLayoutType: LayoutType) =>  {
  if (mediaLayoutType === LayoutType.Split && mediaType !== MediaType.SPOTLIGHT && presenterLength >= 1) return sidebarWithSpotlightClasses
  if (mediaType !== MediaType.SPOTLIGHT && presenterLength < 1) return sidebarHidden
  if (mediaType === MediaType.SPOTLIGHT && presenterLength < 2) return sidebarHidden
  return presenterLength < 7 ? sidebarClasses : sidebarClassesSmallerWidth
}

const sidebarClasses = styles['presenter-screen__layouts--sidebar']

const sidebarWithSpotlightClasses = classnames(
  sidebarClasses,
  styles['presenter-screen__layouts--sidebar--sidebarSpotlight']
)

const sidebarClassesSmallerWidth = classnames(
  sidebarClasses,
  styles['presenter-screen__layouts--sidebar-smaller-width']
)

const sidebarHidden = classnames(
  sidebarClasses,
  styles['presenter-screen__layouts--sidebar-hidden']
)

const LayoutPresenterScreen: FC<LayoutPresenterScreenProps> = ({ presenters, observers, maxPresenters, focusedPresenter, screenSharingPresenter, mediaType,
  sideBarActive, isBridgeInstance, mediaLayoutType, autoSpotlight, muted }) =>
  <div className={mediaType === MediaType.SPOTLIGHT && !isBridgeInstance ? styles['presenter-screen-container'] : styles['media-screen-container']}>
    <div
      data-bdd='layout-presenter-screen'
      className={sideBarActive ? getSidebarClasses(removeObservers(presenters).length, mediaType, mediaLayoutType) : styles['presenter-screen__layouts']}>
      <ScreenGroup>
        {
          getScreenFromMediaType(mediaType, presenters, observers, maxPresenters, focusedPresenter, screenSharingPresenter, muted)
        }
      </ScreenGroup>
      {
        sideBarActive &&
        <LayoutsSidebar
          focusedPresenter={focusedPresenter}
          presenters={removeObservers(presenters)}
          autoSpotlight={autoSpotlight}
          mediaType={mediaType}
          maxPresenters={maxPresenters}
          isSplitView={mediaLayoutType === LayoutType.Split && mediaType !== MediaType.SPOTLIGHT}
          isBridgeInstance={isBridgeInstance}
        />
      }
    </div>
    { (mediaType === MediaType.SPOTLIGHT && !isBridgeInstance) && <SpotlightControls /> }
  </div>

export default LayoutPresenterScreen
